import React from 'react';

import Main from '@views/Settings/Settings';

export default function AppInformationPage() {
  return <Main />;
}
